import React from 'react';
import {Box, Container, Grid, Typography} from '@mui/material';

const ForWhomCourse: React.FC = () => {
    const images = ["Photo1.webp",
        "Photo3.webp",
        "Photo2.webp",
        "Photo4.webp"];

    return (
        <Container
            id="for-whom-course"
            maxWidth={false}
            disableGutters
            sx={{
                px: {xs: 3, sm: 4, md: 5, lg: 6},
                py: {xs: 4, lg: 8},
            }}
        >
            <Grid container spacing={4} alignItems="flex-start">
                <Grid item xs={12} lg={6}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Kyiv Type Serif',
                            fontWeight: 700,
                            fontSize: {xs: '2.5rem', md: '4rem'},
                            lineHeight: {xs: '44px', sm: '58px', md: '72px', lg: '96px'},
                            mb: 2,
                            textAlign: {xs: 'center', lg: 'left'},
                        }}
                    >
                        Для кого курс
                    </Typography>

                    <Box sx={{maxWidth: {xs: '100%', md: '80%', lg: '450px'}, mx: {xs: 'auto', lg: 0}}}>
                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontSize: {xs: '18px', md: '19px', lg: '20px'},
                                fontWeight: 400,
                                mb: 3,
                                mt: 3,
                                textAlign: {xs: 'center', lg: 'left'},
                            }}
                        >
                            Якщо ви учень або учениця 11 класу, і ви:
                        </Typography>

                        <Box
                            component="ul"
                            sx={{
                                listStyle: 'none',
                                p: 0,
                                m: 0,
                                '& li': {
                                    color: '#062159',
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: {xs: '16px', md: '18px', lg: '20px'},
                                    fontWeight: 400,
                                    mb: {xs: 2, md: 3, lg: 4},
                                    pl: 3,
                                    position: 'relative',
                                    '&::before': {
                                        content: '"•"',
                                        position: 'absolute',
                                        left: 0,
                                    },
                                },
                            }}
                        >
                            <li>
                                Визначаєтесь із вибором університету для вступу або хочете перевірити
                                обрану спеціальність
                            </li>
                            <li>Прагнете дізнатися більше про Києво-Могилянську академію</li>
                            <li>Шукаєте підтримки у виборі майбутньої професії</li>
                            <li>
                                Хочете розвинути навички, які стануть ключовими в майбутньому: критичне
                                мислення, співпраця та лідерство
                            </li>
                        </Box>
                    </Box>

                    <Typography
                        sx={{
                            fontFamily: 'Kyiv Type Sans',
                            fontSize: {xs: '18px', md: '19px', lg: '20px'},
                            fontWeight: 400,
                            mt: 2,
                            textAlign: {xs: 'center', lg: 'left'},
                        }}
                    >
                        <Box component="span" sx={{fontWeight: 700}}>
                            KMA Winter School
                        </Box>{' '}
                        саме для вас!
                    </Typography>
                </Grid>

                <Grid item xs={12} lg={6}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)'},
                            gridTemplateRows: {xs: 'repeat(4, auto)', sm: 'repeat(3, auto)'},
                            gap: {xs: 1.5, sm: 2},
                        }}
                    >
                        {images.map((imageSrc, index) => (
                            <Box
                                key={index}
                                component="img"
                                src={`forwhom/${imageSrc}`}
                                alt={`Image ${index + 1}`}
                                sx={{
                                    borderRadius: '8px',
                                    objectPosition: 'center 25%',
                                    minHeight: {
                                        xs: '170px',
                                        sm: index === 0 || index === 3 ? '150px' : '250px',
                                        md: index === 0 || index === 3 ? '200px' : '300px',
                                        lg: index === 0 || index === 3 ? '240px' : '340px',
                                    },
                                    maxHeight: {
                                        xs: '170px',
                                        sm: index === 0 || index === 3 ? '150px' : '250px',
                                        md: index === 0 || index === 3 ? '200px' : '300px',
                                        lg: index === 0 || index === 3 ? '240px' : '340px',
                                    },
                                    width: '100%',
                                    objectFit: 'cover',
                                    gridColumn: {sm: index < 2 ? 1 : 2},
                                    gridRow: {
                                        sm:
                                            index === 0
                                                ? '1 / 2'
                                                : index === 1
                                                    ? '2 / 4'
                                                    : index === 2
                                                        ? '1 / 3'
                                                        : '3 / 4',
                                    },
                                }}
                            />
                        ))}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ForWhomCourse;
